
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../Global/axios";
import nodeinstance from "../../nodeInstance";

const getprojectInchargeSummary = createAsyncThunk("api/project-summary", async (token) => {
  try {
    const response = await nodeinstance.get("/dashboard/loanAdvance/projectSummary", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.data;
  } catch (e) {
    throw new Error(e.message);
  }
});

const projectInchangeData = createSlice({
  name: "project-summary",
  initialState: {
    data: null,
    error: "",
    status: false,
    isLoading: false,
  },
  reducers: {}, // You can define your other regular reducers here if needed.
  extraReducers: (builder) => {
    builder
      .addCase(getprojectInchargeSummary.fulfilled, (state, action) => {
        state.data = action.payload;
        state.isLoading = false;
        state.status = true
      })
      .addCase(getprojectInchargeSummary.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getprojectInchargeSummary.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export { getprojectInchargeSummary };
export default projectInchangeData.reducer;
